import Compare from '@/compare';
import EventBus from '@/event-bus';
import _Singleton from '@/tools/singleton';
import jquery from 'jquery';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import _toNumber from 'lodash/toNumber';

import options from '@/ui/ui_compare/default-selectors.json';
import defaultSettings from '@/ui/ui_compare/default-settings.json';

/**
* @class
* @private
*
* @description
* DOM + Compare
*/
var CompareDOM = function() {
  var self = this;

  document.addEventListener('DOMContentLoaded', function(event) {
    self._init();
  });
};

/**
* Инициализация
* @method
* @private
*/
CompareDOM.prototype._init = function() {
  var self = this;
  self.products = [];
  self.options = options;
  self.defaultSettings = defaultSettings;
  self._bindAddItem();
  self._bindDeleteItem();
  self._bindClearCompare();
  self._bindTrigger();

  EventBus.subscribe('update_items:insales:compares', function(data) {
    self.products = data.products || [];
    jquery(self.options.counter.attr).html(data.products.length);

    if (data.products.length <= 0) {
      jquery(self.options.counterBtn.attr).addClass(self.defaultSettings.classes.compareEmpty);
      jquery(self.options.counter.attr).addClass(self.defaultSettings.classes.compareEmpty);
    } else {
      jquery(self.options.counterBtn.attr).removeClass(self.defaultSettings.classes.compareEmpty);
      jquery(self.options.counter.attr).removeClass(self.defaultSettings.classes.compareEmpty);
    }
  });
};

/**
* Обработчик добавления
* @method
* @private
*
* @listens always:insales:compares
*/
CompareDOM.prototype._bindAddItem = function() {
  var self = this;

  jquery(document).on('click', self.options.add.attr, function(event) {
    event.preventDefault();
    var $button = jquery(this); // eslint-disable-line vars-on-top

    if (!$button.prop(self.options.inProcess.value)) {
      $button.prop(self.options.inProcess.value, true);
      self._addItem($button);
    }
  });

  EventBus.subscribe('always:insales:compares', function(eventData) {
    var try_added = (eventData.method == 'add_item' || eventData.method == 'overload');
    if (eventData.button && try_added) {
      eventData.button.prop(self.options.inProcess.value, false);
    }
  });
};

/**
* Обработчик триггера
* @method
* @private
*
*/
CompareDOM.prototype._bindTrigger = function() {
  var self = this;

  EventBus.subscribe('update_items:insales:compares', function(data) {
    self.products = data.products || [];

    jquery(self.options.trigger.attr).each(function() {
      var $button = jquery(this);
      var id = $button.attr(self.options.trigger.value);
      var check = self._checkCompare(id);

      toggleClass(check, $button);
      toggleText(check, $button);
    });
  });

  jquery(document).on('click', self.options.trigger.attr, function(event) {
    event.preventDefault();
    var $button = jquery(this); // eslint-disable-line vars-on-top
    var id = $button.attr(self.options.trigger.value);
    var check = self._checkCompare(id);

    if (check) {
      toggleClass(check, $button);
      toggleText(check, $button);
      self._deleteItem($button);
    } else {
      toggleClass(check, $button);
      toggleText(check, $button);
      self._addItem($button);
    }
  });

  function toggleText(check, $button) {
    var textNotAdded = jquery($button).find(self.options.triggerNotAddedText.attr);
    var textNotAddedIn = textNotAdded.attr(self.options.triggerNotAddedText.value);
    var textAdded = jquery($button).find(self.options.triggerAddedText.attr);
    var textAddedIn = textAdded.attr(self.options.triggerAddedText.value);

    if (check) {
      textAdded.html(textAddedIn);
    } else {
      textNotAdded.html(textNotAddedIn);
    }
  }

  function toggleClass(check, $button) {
    if (check) {
      jquery($button)
        .removeClass(self.defaultSettings.classes.compareNotAdded)
        .addClass(self.defaultSettings.classes.compareAdded);
    } else {
      jquery($button)
        .removeClass(self.defaultSettings.classes.compareAdded)
        .addClass(self.defaultSettings.classes.compareNotAdded);

      if (self.products.length == 4) {
        jquery($button).addClass(self.defaultSettings.classes.compareLimit);
      } else {
        jquery($button).removeClass(self.defaultSettings.classes.compareLimit);
      }
    }
  }
};

/**
* Добавлен ли уже товар в сравнение
* @method
* @private
*
*/
CompareDOM.prototype._checkCompare = function(id) {
  var self = this;
  var productId = _toNumber(id);
  var ids = _map(self.products, 'id');

  return _includes(ids, productId);
};

/**
* Обработчик очистки
* @method
* @private
*
* @listens always:insales:compares
*/
CompareDOM.prototype._bindClearCompare = function() {
  var self = this;

  jquery(document).on('click', self.options.clear.attr, function(event) {
    event.preventDefault();
    var $button = jquery(this); // eslint-disable-line vars-on-top

    if (!$button.prop(self.options.inProcess.value)) {
      $button.prop(self.options.inProcess.value, true);
      self._clearCompare($button);
    }
  });

  EventBus.subscribe('always:insales:compares', function(eventData) {
    var try_clear = (eventData.method == 'clear' || eventData.method == 'overload');

    if (eventData.button && try_clear) {
      eventData.button.prop(self.options.inProcess.value, false);
    }
  });
};

/**
* Основаня логика добавления товара в сравнение по кнопке
* @method
* @private
*
* @param {Object} $button - jQuery-нода кнопки
*/
CompareDOM.prototype._addItem = function($button) {
  var self = this;
  if ($button.attr(self.options.add.value)) {
    var bind = self.options.add.value;
  } else {
    var bind = self.options.trigger.value;
  }
  var task = {
    button: $button,
    item: parseInt($button.attr(bind))
  };

  Compare.add(task);

  return;
};

/**
* Обработчик удаления
* @method
* @private
*
* @listens always:insales:compares
*/
CompareDOM.prototype._bindDeleteItem = function() {
  var self = this;

  jquery(document).on('click', self.options.delete.attr, function(event) {
    event.preventDefault();
    var $button = jquery(this); // eslint-disable-line vars-on-top

    if (!$button.prop(self.options.inProcess.value)) {
      $button.prop(self.options.inProcess.value, true);
      self._deleteItem($button);
    }
  });

  EventBus.subscribe('always:insales:compares', function(eventData) {
    if (eventData.button && eventData.method == 'remove_item') {
      eventData.button.prop(self.options.inProcess.value, false);
    }
  });
};

/**
* Основаня логика удаления товара из сравнения по кнопке
* @method
* @private
*
* @param {Object} $button - jQuery-нода кнопки
*/
CompareDOM.prototype._deleteItem = function($button) {
  var self = this;

  if ($button.attr(self.options.delete.value)) {
    var bind = self.options.delete.value;
  } else {
    var bind = self.options.trigger.value;
  }

  var task = {
    button: $button,
    item: parseInt($button.attr(bind))
  };

  Compare.remove(task);
};

/**
* Очистка сравнения по кнопке
* @method
* @private
*
* @param {Object} $button - jQuery-нода кнопки
*/
CompareDOM.prototype._clearCompare = function($button) {
  var self = this;
  var task = {
    button: $button,
    item: parseInt($button.attr(self.options.clear))
  };

  Compare.clear(task);
};

/**
* @private
*
* @description
* Получение текста из словаря базовых сообщений
*/
CompareDOM.prototype._getMessageByLocale = function(messageName) {
  var self = this;

  if (typeof self.locale !== 'undefined') {
    var result_message = self.defaultSettings[messageName][self.locale];

    if (typeof result_message === 'undefined') {
      result_message = self.defaultSettings[messageName].ru;
    }

    return result_message;
  }

  return self.defaultSettings[messageName].ru;
};

export default _Singleton(CompareDOM).getInstance();
